export const getResourceString = (keyName) => {
  if (typeof (window as any).formResourceStrings !== "undefined") {
    return (window as any).formResourceStrings[keyName] || "";
  }
  else if (typeof (window as any).errorResourceStrings !== "undefined") {
    return (window as any).errorResourceStrings[keyName] || "";
  }
  return "";
};